module.exports = __webpack_public_path__ + "static/blog_placeholder-430090f4983eefd8476b8b5c566f7b7d.png";